import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { classes } from '@lite-workspace/shared/helm-ui/utils';
import { type VariantProps, cva } from 'class-variance-authority';
import { INK_TONES } from './tone';

const spinnerVariants = cva(
  'inline-block shrink-0 rounded-full border-2 border-current border-t-transparent motion-safe:animate-spin',
  {
    variants: {
      tone: {
        ...INK_TONES,
        // Faint track with an accent head — the admin loading idiom.
        'acc-track': 'border-line border-t-acc',
        'on-media': 'border-on-media/40 border-t-on-media',
      },
    },
    defaultVariants: {
      tone: 'inherit',
    },
  },
);

export type SpinnerVariants = VariantProps<typeof spinnerVariants>;

@Component({
  selector: 'hlm-spinner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'data-slot': 'spinner',
    role: 'status',
    '[attr.aria-label]': 'ariaLabel()',
    '[style.width.px]': 'size()',
    '[style.height.px]': 'size()',
  },
  template: ``,
})
export class HlmSpinner {
  /** Diameter in px — ports the app-spinner numeric size API. */
  public readonly size = input(16);

  public readonly tone = input<SpinnerVariants['tone']>('inherit');

  /** Aria label for the spinner for accessibility. Product copy is Russian. */
  public readonly ariaLabel = input<string>('Загрузка', { alias: 'aria-label' });

  constructor() {
    classes(() => spinnerVariants({ tone: this.tone() }));
  }
}
